<template>
    <div>
        <v-card class="mt-2 rounded-lg" outlined>
            <!-- Informações do médico e o local de atendimento -->
            <v-toolbar color="#006064" dark >
                <!-- Botão para voltar à página inicial -->
                <v-btn icon class="mt-0" @click="voltar">
                    <v-icon color="orange ligthen-3">mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-title>

                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="white">mdi-account</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="text-sm-left font-weight-bold">
                                    {{ medico.nome }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ medico.descricaoLocal }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                </v-toolbar-title>
            </v-toolbar>

            <div v-if="loading">
                <v-card flat width="434">
                    <div v-for="i in 6" :key="i">
                        <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line" :loading="true" title="Aguardando pacientes"></v-skeleton-loader>
                    </div>
                </v-card>
            </div>

            <div v-else-if="listaDePacientes.length > 0">
                <v-text-field color="#006064" v-model="search" dense outlined class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="mdi-magnify" label="Buscar paciente"/>
                <v-list :dense="true" class="scroll-y pt-0 mb-1" style="" two-line>
                    <v-virtual-scroll :bench="0" :items="filteredPatients" height="410" item-height="64">
                        <template v-slot:default="{ item }">
                            <v-list-item two-line :key="item.title" ripple class="animated fadeIn">
                                <v-list-item-avatar>
                                    <strong> {{ filteredPatients.indexOf(item) + 1 }} </strong>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <p class="text-sm-left font-weight-bold">
                                            {{ item.nomePaciente }}
                                        </p>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.nomeExame }} -
                                        {{ item.nomeEspecialidade }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider />
                        </template>
                    </v-virtual-scroll>
                </v-list>
            </div>
        </v-card>
        <v-alert dense text type="warning" class="mt-2">
  A fila é dinâmica e a posição do paciente pode ser melhor para outro médico.
</v-alert>
    </div>
    </template>

<script>
import medicoService from '../../services/medico.service'

export default {
  name: 'fila-medica',
  props: {
    medico: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      medicos: [],
      user: null,
      listaDePacientes: [],
      search: '',
      loading: false
    }
  },
  computed: {
    filteredPatients () {
      return this.listaDePacientes.filter(patient => patient.nomePaciente.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  methods: {
    voltar () {
      // emite um evento para o componente pai
      this.$emit('voltar')
    },
    retornarPacientesDisponiveis () {
      this.loading = true
      medicoService.medico
        .retornarPacientesDisponiveis2(
          this.medico.servicos,
          false,
          this.medico.descricaoLocal,
          1,
          this.medico.idUsuario,
          this.user.idUnidade
        )
        .then(rsp => {
          if (rsp.data) {
            this.listaDePacientes = rsp.data
          }
          this.loading = false
        })
        .catch(err => {
          console.error(err)
          this.loading = false
        })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
  },
  watch: {
    medico: function () {
      this.retornarPacientesDisponiveis()
    }
  }
}
</script>
